import { useOverlayContext } from 'seagull';
import { MapContactsModal } from "./MapContactsModal";
import { jsx as _jsx } from "react/jsx-runtime";
export const useOpenMapContactsModal = (clientContactId, reload) => {
  const overlayContext = useOverlayContext();
  return async function openMapContactsModal(accounting) {
    await overlayContext.showModal({
      closeOnClickOutside: false,
      closeOnEscapeKey: false,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(MapContactsModal, {
          dismissModal: dismissModal,
          contactIds: clientContactId != null ? [clientContactId] : undefined,
          onChange: () => reload(),
          accounting: accounting
        });
      }
    });
  };
};